module.exports = __webpack_public_path__ + "img/chess_japanchess07.e084189f.png";